import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../styles/EmployeeRegister.css";

function Register() {
  const [formData, setFormData] = useState({
    employeeId: "",
    name: "",
    dob: "",
    companyEmail: "",
    personalEmail: "",
    mobile: "",
  });

  // ✅ New state for success/error messages
  const [message, setMessage] = useState({ text: "", type: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
    setMessage({ text: "", type: "" }); // Clear message on input
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "/api/employees/register",
        formData
      );

      // Show success message
      setMessage({ text: "Registration successful!", type: "success" });

      // Clear form
      setFormData({
        employeeId: "",
        name: "",
        dob: "",
        companyEmail: "",
        personalEmail: "",
        mobile: "",
      });
    } catch (error) {
      console.error("Error registering employee:", error);

      // Show error message
      if (error.response && error.response.status === 400) {
        setMessage({ text: "Please fill all required fields.", type: "error" });
      } else {
        setMessage({ text: "Error occurred while registering. Try again.", type: "error" });
      }
    }
  };

  return (
    <div className="register-wrapper">
      <div className="bubbles">
        {[...Array(8)].map((_, i) => (
          <div className="bubble" key={i}></div>
        ))}
      </div>
      <div className="register-back-container">
        <Link to="/" className="back-home-link">← Back to Home</Link>
      </div>
      <div className="register-card">
        <h2>Employee Registration Form</h2>
        <form className="register-form" onSubmit={handleSubmit}>
          <label htmlFor="employeeId">Employee ID:</label>
          <input
            type="text"
            id="employeeId"
            placeholder="Enter your ID"
            value={formData.employeeId}
            onChange={handleChange}
            required
          />

          <label htmlFor="name">Employee Name:</label>
          <input
            type="text"
            id="name"
            placeholder="Enter full name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <label htmlFor="dob">Date of Birth:</label>
          <input
            type="date"
            id="dob"
            placeholder="dd-mm-yyyy"
            value={formData.dob}
            onChange={handleChange}
            required
          />

          <label htmlFor="companyEmail">Company Email:</label>
          <input
            type="email"
            id="companyEmail"
            placeholder="example@company.com"
            value={formData.companyEmail}
            onChange={handleChange}
            required
          />

          <label htmlFor="personalEmail">Personal Email:</label>
          <input
            type="email"
            id="personalEmail"
            placeholder="example@gmail.com"
            value={formData.personalEmail}
            onChange={handleChange}
            required
          />

          <label htmlFor="mobile">Mobile No.:</label>
          <input
            type="tel"
            id="mobile"
            placeholder="Enter mobile number"
            value={formData.mobile}
            onChange={handleChange}
            required
          />

          <button type="submit">Register</button>

          {/* ✅ Display message below the button */}
          {message.text && (
            <p
              style={{
                color: message.type === "success" ? "green" : "red",
                marginTop: "10px",
                fontWeight: "bold",
              }}
            >
              {message.text}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}

export default Register;
